module.exports = __webpack_public_path__ + "static/img/qysm5.c8bc4de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/qysm5.png
// module id = neju
// module chunks = 0